import * as React from 'react';
import { Level, liveAnnounce } from '@egds/react-core/utils';
import { useLocalization } from '@shared-ui/localization-context';
export const AnnounceLoadingState = ({
  isLoading,
  isError
}) => {
  const l10n = useLocalization();
  const [lastLoadingStateMessage, setLastLoadingStateMessage] = React.useState('');
  const a11yLabel = l10n === null || l10n === void 0 ? void 0 : l10n.formatText('hotels.searchResults.resultsUpdated.liveAnnounce');
  let message;
  if (isLoading) {
    message = l10n === null || l10n === void 0 ? void 0 : l10n.formatText('hotels.searchResults.resultsLoading.liveAnnounce');
  } else if (isError) {
    message = l10n === null || l10n === void 0 ? void 0 : l10n.formatText('hotels.searchResults.errorRetrievingResults.liveAnnounce');
  } else {
    message = a11yLabel;
  }
  if (message !== lastLoadingStateMessage) {
    liveAnnounce(message, Level.POLITE);
    setLastLoadingStateMessage(message);
  }
  return null;
};
AnnounceLoadingState.displayName = 'AnnounceLoadingState';